export default __webpack_public_path__ + "static/media/dashboardOverview.64ad6fb8.png";